import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { FdMeasurementApplication } from 'Components/Worksheets/NuclearFieldDensityWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';

let ResultsSectionBase = ({ createWorksheetSelector }: IWorksheetComponent): JSX.Element => {
  const shouldShowOtherResults = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.MeasurementApplication'),
      (d) => d === FdMeasurementApplication.AbsoluteTests
    )
  );

  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} label="Moisture Content (%)" name="MoistureContent" />
        <Field input={<TextOutput />} label="Dry Density" name="DryDensity" />
        <Field input={<TextOutput />} name="MaximumDryDensity" visible={!shouldShowOtherResults} />
        <Field input={<TextOutput />} name="OptimumMoistureContent" visible={!shouldShowOtherResults} />
        <Field input={<TextOutput />} name="RelativeCompaction" visible={!shouldShowOtherResults} />
        <Field input={<TextOutput />} name="AirVoids" visible={!shouldShowOtherResults} />
      </ListFieldSection>
      <ListFieldSection heading="Report" visible={!shouldShowOtherResults}>
        <Field input={<RadioGroup />} name="ReportResultsOption" />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export default ResultsSection;
export { ResultsSection };
